
import axios from 'axios';

const API_URL = import.meta.env.VITE_API_BASE_URL || '/api/v1';

export const getWebinarByAccount = async (accountId) => {
  try {
    const response = await axios.get(`${API_URL}/webinars?account_id=${accountId}`);
    console.log('Webinar API Response:', response.data); // For debugging
    
    
    const webinarData = Array.isArray(response.data) 
      ? response.data[0] 
      : response.data.data || response.data;
    
    console.log('Processed Webinar Data:', webinarData); // For debugging
    return webinarData;
  } catch (error) {
    console.error('Error fetching webinar:', error);
    return null;
  }
};